import { SignalsTab } from "@/components/signals/SignalsTab";

export function SignalsPage() {
  return (
    <div className="px-6 py-5">
      <div className="mb-5">
        <h1 className="font-display text-[20px] font-bold leading-tight">Signals</h1>
        <p className="text-[12px] text-muted-foreground">
          Suggested Intensity and Pod changes from NOS Guidance — triage, confirm, or dismiss.
        </p>
      </div>

      <SignalsTab />
    </div>
  );
}
